var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.76,14.28c-2.12-4.77-7.08-8.15-12.59-8.15-7.61,0-13.75,6.14-13.75,13.75s6.14,13.75,13.75,13.75c3.19,0,6.13-1.08,8.46-2.89l-.92-1.18c-2.07,1.62-4.69,2.58-7.53,2.58-6.79,0-12.25-5.46-12.25-12.25S12.39,7.64,19.17,7.64c4.9,0,9.33,3.02,11.21,7.25l1.37-.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.43,6.05l-1,7.7-7.7-1-.19,1.49,9.19,1.19,1.19-9.19-1.49-.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.12,7.07c-4.87-1.87-10.75-.82-14.64,3.07-5.38,5.38-5.38,14.06,0,19.45,5.38,5.38,14.06,5.38,19.45,0,2.26-2.26,3.57-5.1,3.93-8.03l-1.49-.18c-.32,2.61-1.49,5.14-3.51,7.15-4.8,4.8-12.53,4.8-17.32,0-4.8-4.8-4.8-12.53,0-17.32,3.46-3.46,8.71-4.41,13.03-2.74l.55-1.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.fc24022876ac0b1b57e9b9d8b794168e.svg";
export { ForwardRef as ReactComponent };